<template>
  <div id="special-pdf">
    <ipub-model :title="'Generate Special Issue '+this.type"
                width="920px"
                :visable="isVisable"
                @confirm="confirm"
                confirmText="Generate"
                @cancel="cancel">
      <ipub-form ref="add-pdf-form"
                 :model="params"
                 :rules="rules">
        <ipub-form-item v-if="type==='Flyer'"
                        prop="summary"
                        label="Special Issue Information">
          <ipub-editor :height="200"
                       placeholder="Special Issue Information"
                       v-model.trim="params.summary" />
        </ipub-form-item>
        <ipub-form-item prop="url"
                        label="Special Issue URL">
          <ipub-input placeholder="Special Issue URL"
                      v-model.trim="params.url" />
        </ipub-form-item>
        <div class="ipub-line mar-b-20"></div>
        <div v-for="(item, index) in params.editorList"
             :key="item.id">
          <div class="ipubw-p1 mar-b-8"
               v-if="params.editorList.length>1">{{['First', 'Second', 'Third'][index]}} Guest Editor</div>
          <ipub-row :gutter="40">
            <ipub-col :span="9">
              <ipub-row :gutter="20">
                <ipub-col :span="4">
                  <ipub-form-item prop="firstName"
                                  label="First Name">
                    <ipub-input placeholder="First Name"
                                v-model.trim="item.firstName" />
                  </ipub-form-item>
                </ipub-col>
                <ipub-col :span="4">
                  <ipub-form-item prop="lastName"
                                  label="Last Name">
                    <ipub-input placeholder="Last Name"
                                v-model.trim="item.lastName" />
                  </ipub-form-item>
                </ipub-col>
                <ipub-col :span="4">
                  <ipub-form-item prop="email"
                                  label="Email">
                    <ipub-input placeholder="Email"
                                v-model.trim="item.email" />
                  </ipub-form-item>
                </ipub-col>
              </ipub-row>
              <ipub-form-item prop="affiliation"
                              label="Affiliations">
                <ipub-input placeholder="Affiliations"
                            v-model.trim="item.affiliation" />
              </ipub-form-item>
              <ipub-form-item prop="degreesIdList"
                              label="Degree / Credential">
                <ipub-select placeholder="Degree / Credential"
                             :tree="true"
                             search
                             mode="multiple"
                             @search="getDegrees"
                             v-model="item.degreesIdList">
                  <ipub-select-option v-for="item in degreesList"
                                      :key="item.id"
                                      :value="item.name">{{item.fullName}}({{item.name}})</ipub-select-option>
                </ipub-select>
              </ipub-form-item>
            </ipub-col>
            <ipub-col :span="3">
              <ipub-form-item prop="icon">
                <div class="upload-content right-option">
                  <div class="upload-content-img">
                    <ipub-upload-cropper @change="(e)=>{handleUpload(index, e)}"
                                         :canWidth="105"
                                         :canHeight="130"
                                         :scales="2"
                                         :imgUrl="item.icon?domain+'/'+item.icon:domain+'/imageFile/icon.svg'" />
                  </div>
                </div>
              </ipub-form-item>
            </ipub-col>
          </ipub-row>
          <div class="ipub-line mar-b-20"></div>
        </div>
        <ipub-form-item prop="scale"
                        label="File Quality (The file size will increase with the file quality, please select the file quality that meets your needs)">
          <ipub-select placeholder="File Quality"
                       v-model="scale">
            <ipub-select-option v-for="item in 4"
                                :key="'scale'+item"
                                :value="item">{{item}} Level</ipub-select-option>
          </ipub-select>
        </ipub-form-item>
        <ipub-form-item prop="preview"
                        label="Preview">
          <div class="showPDFDialog"
               :style="type==='Banner'?'':'height:450px;width:320px;border: 1px solid #e9eef0;'">
            <div id="showPDFDialog"
                 :style="type==='Banner'?'height:1226px;width:1980px':'width:1280px;height:1800px'">
              <template v-if="type==='Banner'">
                <div class="pdf-content banner-content"
                     :style="`background-image:url(${sbg[journalDetail.name]})`">
                  <div class="pdf-content-icon">
                    <div class="tl">
                      <img :src="jLogo[journalDetail.name]"
                           alt="">
                    </div>
                    <div class="tr"
                         style="font-size:26px">
                      <div>an Open Access journal by IMR Press</div>
                      <div style="display:inline-block">
                        <div class="pdf-content-icon-r">
                          <div v-if="journalDetail.databaseInclusion&&journalDetail.databaseInclusion.includes('Clarivate')"
                               :style="`border-color:${journalDetail.mainColor}`">
                            <div>
                              IMPACT<br />
                              FACTOR
                            </div>
                            <div :style="`color:${journalDetail.mainColor}`"><strong>{{journalDetail.impactFactor}}</strong></div>
                          </div>
                          <div v-if="journalDetail.databaseInclusion&&journalDetail.databaseInclusion.includes('Scopus')"
                               :style="`border-color:${journalDetail.mainColor}`">
                            <div>Citescore</div>
                            <div :style="`color:${journalDetail.mainColor}`"><strong>{{journalDetail.citationScore}}</strong></div>
                            <div>Scopus</div>
                          </div>
                          <div v-if="journalDetail.databaseInclusion&&journalDetail.databaseInclusion.includes('PubMed')"
                               :style="`border-color:${journalDetail.mainColor}`">
                            <div>Covered in</div>
                            <div><img :src="pubmed"
                                   alt=""></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div :class="'editor-'+params.editorList.length">
                    <div class="banner-content-detail">
                      <div class="ipub-h1 banner-content-title">
                        <div v-html="params.title"></div>
                      </div>
                      <div class="banner-content-time"
                           :style="`color:${journalDetail.mainColor}`">
                        <ipub-icon type="iconTime" /> Deadline: {{$moment(params.endTime).format('DD MMMM YYYY')}}
                      </div>
                    </div>
                    <div class="banner-content-ge">
                      <div style="font-size:35px"
                           class="mar-b-20"
                           v-if="params.editorList.length>1">Guest Editors</div>
                      <div class="banner-content-editors">
                        <div class="banner-content-editor"
                             v-for="item in params.editorList"
                             :key="'banner'+item.id">
                          <div v-if="item.avatar"
                               class="banner-content-editor-avatar"
                               :style="`border-color:${journalDetail.mainColor}`">
                            <img :src="item.avatar"
                                 alt="">
                          </div>
                          <div v-else
                               class="banner-content-editor-avatar-wrap"></div>
                          <div class="banner-content-editor-detail">
                            <div style="font-size:35px"
                                 class="mar-b-30"
                                 v-if="params.editorList.length===1">Guest Editor</div>
                            <div class="ipub-h1 banner-content-editor-detail-name">
                              {{item.firstName}} {{item.lastName}}<template v-if="item.degreesIdList && item.degreesIdList.length">, {{item.degreesIdList.join(', ')}}</template>
                            </div>
                            <div class="banner-content-editor-detail-aff font-color">
                              <div v-for="(item, index) in item.affiliation.split(';')"
                                   :key="'affiliations' + index">{{item}}</div>
                            </div>
                            <div class="banner-content-editor-detail-email">
                              <ipub-icon :style="`color:${journalDetail.mainColor}`"
                                         type="iconEmail" /> {{item.email}}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pdf-content-num"
                       style="color:#415465">
                    {{params.url}}
                  </div>
                  <div class="banner-content-sign"
                       :style="`color:${journalDetail.mainColor}`">
                    <div class="banner-content-sign-special">
                      Special Issue
                    </div>
                    <div class="banner-content-sign-paper">
                      CALL FOR PAPER
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="type==='Flyer'">
                <div class="pdf-content flyer-content">
                  <div class="flyer-content-icon">
                    <div class="tl">
                      <img :src="jLogo[journalDetail.name]"
                           alt="">
                    </div>
                    <div class="ipub-p2 tr"
                         style="font-size:17px;line-height:22px">
                      <div>an Open Access journal of IMR Press</div>
                      <div><template v-if="journalDetail.eissn">Electronic ISSN: {{journalDetail.eissn}}</template><template v-if="journalDetail.issn&&journalDetail.eissn"> | </template><template v-if="journalDetail.issn">Print ISSN: {{journalDetail.issn}}</template></div>
                      <div class="ipub-h1"
                           :style="`font-size: 52px;line-height:69px;color:${journalDetail.mainColor}`">Special Issue</div>
                    </div>
                  </div>
                  <div :style="`background-image: linear-gradient(90deg, ${journalDetail.mainColor+'22'}, ${journalDetail.mainColor+'77'});`"
                       class="flyer-content-line"></div>
                  <div class="flyer-content-detail">
                    <ipub-row :gutter="60">
                      <ipub-col :span="4">
                        <div style="font-size:22px;line-height:30px">Guest Editor<template v-if="params.editorList&&params.editorList.length>1">s</template> </div>
                        <div class="flyer-content-editor"
                             v-for="item in params.editorList"
                             :key="'flyer'+item.id">
                          <div v-if="item.avatar"
                               class="flyer-content-editor-avatar"
                               :style="`border-color:${journalDetail.mainColor}`">
                            <img :src="item.avatar"
                                 alt="">
                          </div>
                          <div class="ipub-h1 flyer-content-editor-name">
                            {{item.firstName}} {{item.lastName}}<template v-if="item.degreesIdList && item.degreesIdList.length">, {{item.degreesIdList.join(', ')}}</template>
                          </div>
                          <div class="flyer-content-editor-aff font-color">
                            <div v-for="(item, index) in item.affiliation.split(';')"
                                 :key="'affiliations' + index">{{item}}</div>
                          </div>
                          <div class="flyer-content-editor-email">
                            <ipub-icon :style="`color:${journalDetail.mainColor}`"
                                       type="iconEmail" /> {{item.email}}
                          </div>
                        </div>
                      </ipub-col>
                      <ipub-col :span="8">
                        <div class="flyer-content-title"
                             v-html="params.title"></div>
                        <div class="banner-content-time mar-b-20"
                             :style="`color:${journalDetail.mainColor}`">
                          <ipub-icon type="iconTime" /> Deadline: {{$moment(params.endTime).format('DD MMMM YYYY')}}
                        </div>
                        <div class="flyer-content-content"
                             v-html="params.summary"></div>
                      </ipub-col>
                    </ipub-row>
                  </div>
                  <div class="flyer-content-bottom">
                    <div class="flyer-content-link">
                      <a class="add-href"
                         :href="`https://www.imrpress.com/journal/${journalDetail.name}/special_issues/${params.code}`">
                        https://www.imrpress.com/journal/{{journalDetail.name}}<br />
                        /special_issues/{{params.code}}
                      </a>
                    </div>
                    <div class="flyer-content-address tr">
                      {{journalDetail.name}} Editorial Office<br />
                      #05-02F, 50 Tagore Lane, <br />
                      787494 Singapore
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </ipub-form-item>

      </ipub-form>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import special from '@/api/special'
import { getUploadConfig } from '@/utils/upload'
import pdfTools from '@/api/pdf_tools'
import { settingOption } from '@/api/setting'
import journal from '@/api/journal'
import operation from '@/api/operation'
import { saveImage, savePDF } from '@/utils/pdf'
import pubmed from '@/assets/pdf/pubmed'
import sbg from '@/assets/pdf/s-bg'
import logo from '@/assets/pdf/publish-logo'
import jLogo from '@/assets/pdf/journal-logo'
import help from '@/utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'Banner',
      validator (val) {
        return ['Banner', 'Flyer'].indexOf(val) !== -1
      }
    },
    journalId: {
      type: String,
      default: ''
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      sbg, pubmed, logo, jLogo,
      params: {
        editorList: [],
        summary: ''
      },
      scale: 2,
      rules: {},
      degreesList: [],
      journalDetail: {
        databaseInclusion: []
      },
      isCropper: false,
      canWidth: 200,
      canHeight: 225,
      indexs: ''
    }
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          editorList: [],
          summary: ''
        }
        this.rules = {}
      } else {
        this.getJournal(this.journalId)
        this.getDegrees()
        this.getQuery()
        if (this.type === 'Flyer') {
          this.scale = 4
        } else if (this.type === 'Banner') {
          this.scale = 2
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      editorialBoard: 'getEditorialBoard',
      domain: 'getDomain'
    })
  },
  mounted () { },
  methods: {
    async confirm () {
      const flag = this.$refs['add-pdf-form'].validate()
      if (flag) {
        const el = document.getElementById('showPDFDialog')
        if (this.type === 'Banner') {
          await saveImage(el, this.scale, `${this.params.code} Banner`)
          await operation.add({
            authorityCode: 'WEBSITE.SPECIAL_ISSUES.DOWNLOAD_BANNER',
            type: 'DOWNLOAD',
            info: `Download Special Issue ${this.type}: ${this.params.code} `,
            detail: `【Website Abbreviation】: ${this.params.code}`
          })
        } else if (this.type === 'Flyer') {
          await savePDF(el, this.scale, `${this.params.code} Flyer`)
          await operation.add({
            authorityCode: 'WEBSITE.SPECIAL_ISSUES.DOWNLOAD_FLYER',
            type: 'DOWNLOAD',
            info: `Download Special Issue ${this.type}: ${this.params.code} `,
            detail: `【Website Abbreviation】: ${this.params.code}`
          })
        }
        this.$emit('confirm', this.params)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    async getQuery () {
      const data = await special.query(this.inputData.id)
      data.url = `https://www.imrpress.com/journal/${this.journalDetail.name}/special_issues/${data.code}`
      this.params = data
      this.params.editorList.forEach((item, index) => {
        item.degreesIdList = item.degreesList ? item.degreesList.map(val => { return val.name }) : []
        if (item.icon) {
          this.getAvatar(item.icon, index)
        }
      })
    },
    async getDegrees (keyword) {
      this.degreesList = await settingOption.get({ keyword, type: 'DEGREE' })
    },
    async getJournal (id) {
      this.journalDetail = await journal.query(id)
    },
    async handleUpload (index, files) {
      this.indexs = index
      const file = files[0]
      const imgTypes = ['image/jpeg', 'image/png']
      if (!imgTypes.includes(file.type)) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].isWrongType
        })
        return false
      }
      const MS = 2
      const maxSize = file.size / 1024 / 1024 < MS
      if (!maxSize) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].notExceed + MS + 'MB'
        })
        return false
      }
      const url = await getUploadConfig(file, `${this.publisherId}/journal/${this.inputData.journalId}/editorial-board/icon/${help.guid()}`)

      if (url.includes('err:')) {
        this.$message.error({
          title: 'Error',
          content: this.LANGUAGE[this.language].uploadFileFail
        })
        return false
      }

      this.$set(this.params.editorList[this.indexs], 'icon', url)
      this.getAvatar(url, this.indexs)
    },
    async getAvatar (url, index) {
      this.$set(this.params.editorList[index], 'avatar', await pdfTools.base64(`${this.domain}/${url}`))
    },
  }
}
</script>

<style lang="scss" scoped>
#special-pdf {
  .upload-content {
    height: 150px;
    width: 150px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    &-img {
      height: 150px;
      width: 150px;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .showPDFDialog {
    height: 333px;
    #showPDFDialog {
      width: 1980px;
      height: 1226px;
      transform: scale(0.25);
      transform-origin: left top;
      .pdf-content {
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        position: relative;
        &-icon {
          padding: 100px 70px 0 70px;
          width: 100%;
          display: flex;
          box-sizing: border-box;
          img {
            height: 120px;
          }
          > div {
            width: 50%;
          }
          &-r {
            display: flex;
            > div {
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;
              width: 110px;
              height: 110px;
              border: 2px solid #ccc;
              border-radius: 50%;
              margin-left: 20px;
              margin-top: 16px;
              font-size: 18px;
              img {
                width: 90px;
                height: 32px;
              }
            }
          }
        }
        &-journal {
          text-align: center;
          font-size: 40px;
          line-height: 56px;
        }
        &-num {
          position: absolute;
          left: 88px;
          bottom: 80px;
          font-size: 28px;
        }
      }
      .banner-content {
        &-sign {
          position: absolute;
          right: 70px;
          bottom: 100px;
          &-special {
            font-size: 94px;
            font-weight: 700;
            font-family: $h_family;
          }
          &-paper {
            font-size: 40px;
            position: absolute;
            bottom: -25px;
            right: 0;
          }
        }
        .editor-1,
        .editor-2,
        .editor-3 {
          padding: 50px 70px;
          box-sizing: border-box;
          .banner-content {
            &-title {
              font-size: 80px;
              line-height: 90px;
              font-weight: 700;
              margin-bottom: 40px;
              > div,
              p,
              h1 {
                font-size: 80px !important;
                line-height: 90px !important;
                font-weight: 700 !important;
                margin-bottom: 40px !important;
              }
            }
            &-time {
              font-size: 50px;
            }
            &-editor {
              display: flex;
              &-avatar {
                width: 300px;
                height: 300px;
                overflow: hidden;
                border: 10px solid #ccc;
                box-sizing: border-box;
                border-radius: 50%;
                background: #ccd6dd;
                margin-right: 50px;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }
              &-detail {
                display: flex;
                flex-direction: column;
                width: calc(100% - 350px);
                &-name {
                  font-size: 54px;
                  line-height: 62px;
                  margin-bottom: 10px;
                }
                &-aff {
                  font-size: 30px;
                  margin-bottom: 20px;
                }
                &-email {
                  font-size: 35px;
                }
              }
            }
          }
        }
        .editor-1 {
          .banner-content {
            &-time {
              margin-bottom: 100px;
            }
            &-editor {
              &-detail {
                justify-content: center;
              }
            }
          }
        }
        .editor-2 {
          .banner-content {
            &-time {
              margin-bottom: 40px;
            }
            &-editors {
              display: flex;
              > div {
                flex: 1;
              }
            }
            &-editor {
              &-avatar {
                width: 180px;
                height: 180px;
                border: 6px solid #ccc;
                margin-right: 20px;
              }
              &-detail {
                width: calc(100% - 260px);
                &-name {
                  font-size: 35px;
                  line-height: 37px;
                }
                &-aff {
                  font-size: 25px;
                  margin-bottom: 40px;
                }
              }
            }
          }
        }
        .editor-3 {
          display: flex;
          .banner-content {
            &-detail {
              width: 55%;
            }
            &-ge {
              width: 45%;
              padding-left: 200px;
              box-sizing: border-box;
            }
            &-editors {
              margin-top: 37px;
            }
            &-editor {
              margin-bottom: 20px;
              &-avatar {
                width: 120px;
                height: 120px;
                border: 3px solid #ccc;
                margin-right: 25px;
              }
              &-avatar-wrap {
                width: 120px;
                margin-right: 25px;
              }
              &-detail {
                width: calc(100% - 145px);
                &-name {
                  font-size: 33px;
                  line-height: 42px;
                }
                &-aff {
                  font-size: 16px;
                  margin-bottom: 10px;
                }
                &-email {
                  font-size: 20px;
                }
              }
            }
          }
        }
      }
      .flyer-content {
        width: 100%;
        height: 100%;
        padding: 80px 110px;
        position: relative;
        box-sizing: border-box;
        font-size: 22px;
        line-height: 34px;
        overflow: hidden;
        &-icon {
          margin-bottom: 10px;
          display: flex;
          > div {
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            img {
              height: 114px;
            }
          }
        }
        &-line {
          height: 10px;
          width: 100%;
          margin-bottom: 20px;
        }
        &-editor {
          margin-top: 20px;
          &-avatar {
            width: 110px;
            height: 110px;
            overflow: hidden;
            border: 4px solid #ccc;
            box-sizing: border-box;
            border-radius: 50%;
            background: #ccd6dd;
            margin-bottom: 10px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          &-name {
            font-size: 26px;
            line-height: 30px;
            font-family: $h_family;
            font-weight: 700;
            margin-bottom: 10px;
          }
          &-aff {
            font-size: 17px;
            line-height: 22px;
            margin-bottom: 10px;
          }
          &-email {
            font-size: 22px;
            white-space: nowrap;
          }
        }
        &-title {
          font-size: 47px;
          line-height: 56px;
          font-weight: 700;
          font-family: $h_family;
          margin-bottom: 10px;
          p,
          div,
          h1 {
            font-size: 47px;
            line-height: 56px;
          }
        }
        &-time {
          font-size: 26px;
          margin-bottom: 20px;
        }
        &-content {
          font-size: 22px;
          line-height: 34px;
          p,
          div {
            font-size: 22px;
            line-height: 34px;
            a {
              color: $link_color;
            }
          }
          a {
            color: $link_color;
          }
        }
        &-bottom {
          position: absolute;
          bottom: 90px;
          display: flex;
          width: calc(100% - 220px);
          align-items: flex-end;
          > div {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.flyer-content-content {
  p,
  div {
    font-size: 22px;
    line-height: 34px;
    a {
      color: $link_color;
    }
  }
  a {
    color: $link_color;
  }
}
</style>
